import axiosInstance from "../axiosInstance";

const BASE_URL = "/settings/gcs-cost";

export const getGcsCostSummary = async ({ from, to } = {}) => {
  const params = {};
  if (from) params.from = from;
  if (to) params.to = to;
  const res = await axiosInstance.get(`${BASE_URL}/summary`, { params });
  return res.data;
};

export const getGcsCostLogs = async ({ from, to, action, page = 1, size = 20 } = {}) => {
  const params = { page, size };
  if (from) params.from = from;
  if (to) params.to = to;
  if (action) params.action = action;
  const res = await axiosInstance.get(`${BASE_URL}/logs`, { params });
  return res.data;
};

export const getGcsActualReport = async ({ from, to } = {}) => {
  const params = {};
  if (from) params.from = from;
  if (to) params.to = to;
  const res = await axiosInstance.get(`${BASE_URL}/actual`, { params });
  return res.data;
};

export const getGcsMonthlyReport = async (month) => {
  const res = await axiosInstance.get(`${BASE_URL}/monthly-report`, { params: { month } });
  return res.data;
};

export const exportGcsCostLogs = async ({ from, to, action, limit = 50000 } = {}) => {
  const params = { limit };
  if (from) params.from = from;
  if (to) params.to = to;
  if (action) params.action = action;
  const res = await axiosInstance.get(`${BASE_URL}/logs/export`, { params });
  return res.data;
};
